import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { pulseTemplateApiToEntity, pulseTemplateEntityToApi } from '../../entities/PulseTemplate/converters';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class PulseTemplateClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createPulseTemplateImpl", void 0);
    _defineProperty(this, "queryPulseTemplatesImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'PulseTemplateClient';
  }
  async createPulseTemplate(template) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        pulseTemplate: created
      } = await this.request(this.createPulseTemplateImpl({
        pulseTemplate: pulseTemplateEntityToApi(template)
      }), ...args);
      if (!created) {
        throw new Error('Invalid pulse template response');
      }
      return this.convertToEntity(created);
    } catch (error) {
      this.logError('createPulseTemplate', 'Failed to create pulse template', {
        template
      }, error);
      throw error;
    }
  }
  async queryPulseTemplates(query) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        pulseTemplates,
        pagingMetadata
      } = await this.request(this.queryPulseTemplatesImpl({
        query: query
      }), ...args);
      if (!pulseTemplates) {
        throw new Error('Received invalid pulse templates');
      }
      return {
        items: pulseTemplates.map(p => this.convertToEntity(p)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryPulseTemplates', 'Failed to query pulse templates', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(api) {
    return pulseTemplateApiToEntity(api);
  }
}
//# sourceMappingURL=PulseTemplateClientBase.js.map